import React from "react";
import Head from "next/head";
import Questionnaire from "components/Questionnaire";
import { getByID as getPage } from "lib/models/Page";
import { getBySlug as getQuiz } from "lib/models/Quiz";
import buildQuiz from "lib/models/QuizBuilder";
import withUser from "lib/user/withUser";
import withGlobalFields from "lib/withGlobalFields";

const Quiz = ({ quiz, user, ...props }) => {
  return (
    <React.Fragment>
      <Head>
        <title>{`${quiz.seo.title || quiz.name} | ${
          props.global.seo.title
        }`}</title>
        <meta name="description" content={quiz.seo.description} />
        <meta
          name="robots"
          content={quiz.status === "draft" ? "noindex" : "all"}
        />
      </Head>

      <Questionnaire
        quiz={quiz}
        user={user.id}
        country={user.country}
        {...props}
      />
    </React.Fragment>
  );
};

export const getServerSideProps = withGlobalFields(
  withUser(async ({ params }, user) => {
    // Slugs always lowercased
    if (params.slug !== params.slug.toLowerCase()) {
      return {
        redirect: {
          destination: `/quiz/${params.slug.toLowerCase()}`,
          permanent: true,
        },
      };
    }

    // Get main quiz
    const quiz = await getQuiz(
      params.slug,
      [
        "name",
        "slug",
        "seo",
        "status",
        "category",
        "overrides",
        "showOutOfStock",
        "ignorePriceChange",
        "onlyOneResult",
        "adsense",
      ],
      user.country
    );

    if (!quiz) {
      return {
        redirect: {
          destination: "/",
          permanent: false,
        },
      };
    }

    // Get page fields
    const { fields } = await getPage("quiz-questions");

    // Build quizzes array for current quiz
    const quizzes = await buildQuiz(quiz.id);

    return { props: { ...fields, quiz, quizzes, user } };
  })
);

export default Quiz;
